var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1355,
    height: 2641,
    viewBox: "0 0 1355 2641",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_436_10041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.822 1037.38L-370.896 1429.75C-405.866 1447.64 -435.204 1474.85 -455.66 1508.38C-476.117 1541.91 -486.894 1580.45 -486.798 1619.73L-486.823 1773.45C-486.823 1778.86 -485.593 1784.19 -483.228 1789.04C-480.863 1793.9 -477.423 1798.16 -473.171 1801.49C-468.918 1804.82 -463.962 1807.14 -458.68 1808.27C-453.398 1809.4 -447.928 1809.32 -442.683 1808.03L391.822 1601.95V1037.38Z",
    fill: "#CCD9FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.297 405.191C411.297 257.689 568.009 6.75449 678.145 6.75453C788.231 6.7545 944.95 257.694 944.95 405.196L944.955 2199.68C944.954 2286.72 934.983 2373.46 915.242 2458.23L872.543 2641.5L483.61 2641.5L440.934 2458.05C421.25 2373.4 411.314 2286.77 411.322 2199.86L411.297 405.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.176 1037.38L1726.89 1429.76C1761.86 1447.64 1791.2 1474.86 1811.66 1508.39C1832.11 1541.92 1842.89 1580.46 1842.8 1619.74L1842.82 1773.46C1842.82 1778.86 1841.59 1784.19 1839.23 1789.05C1836.86 1793.9 1833.42 1798.16 1829.17 1801.49C1824.92 1804.82 1819.96 1807.14 1814.68 1808.27C1809.4 1809.41 1803.93 1809.32 1798.68 1808.03L964.176 1601.96L964.176 1037.38Z",
    fill: "#CCD9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.338 158.732L674.338 97.8081L583.182 156.9L605.169 199.958L674.338 158.732Z",
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.584 158.732V97.8081L773.74 156.9L751.753 199.958L682.584 158.732Z",
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.549 207.288L574.936 166.519L532.793 227.443L578.142 227.443L595.549 207.288Z",
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.371 207.288L781.984 166.519L824.127 227.443L778.778 227.443L761.371 207.288Z",
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.936 236.146H530.961L509.432 317.225L556.613 297.528L574.936 236.146Z",
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.986 236.146L825.961 236.146L847.49 317.225L800.309 297.528L781.986 236.146Z",
    fill: "#F5F8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_436_10041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2279,
    height: 2279,
    fill: "white",
    transform: "translate(-933.498 1368.5) rotate(-45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.75d997bd7a58070dd910eed4feafc6f1.svg";
export { ForwardRef as ReactComponent };